$(document).ready(function ($) {
  // Evento de click para copiar código qrcode
  $(".copy-qrcode").on("click", function (ev) {
    ev.preventDefault();
    const qrcode = $(this).data("codigo");
    ev.preventDefault();
    copyToClipboard(qrcode);
    showAlert(
      "Código copiado",
      "Seu código foi copiado com sucesso.",
      "success"
    );
  });
});
